import React from "react";
import style from './Info.module.css'

import avatar from '../../assets/avatar.png'
import gear from '../../assets/gear.png'
import contact from '../../assets/contact.png'
import ava from '../../assets/photo.jpg'

export const Info = () => {
    return (
        <div className={style.infoBox}>

            <div className={style.contentWrapper}>

                <div className={style.WEB_DEVELOPER_CONTENT}>


                    <div className={`${style.profileInfo} ${style.profile}`}>

                        <div className={style.photo}>
                            <img src={ava}/>
                        </div>

                        <span className={style.title}>
                            Привет!
                        </span>
                        <br/>
                        <span>
                            Я трудолюбив и быстро учусь :)
                        </span>
                    </div>
                </div>

                <div className={style.SKILLS_CONTENT}>
                    <div className={`${style.profileInfo} ${style.competentions}`}>

                        <div className={style.competentionsInfoBlock}>
                            <p>HTML</p>
                        </div>

                        <div className={style.dotsBlock}>

                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                        </div>

                        <div className={style.competentionsInfoBlock}>
                            <p>CSS</p>
                        </div>

                        <div className={style.dotsBlock}>

                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                        </div>

                        <div className={style.competentionsInfoBlock}>
                            <p>JavaScript</p>
                        </div>

                        <div className={style.dotsBlock}>

                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                        </div>

                        <div className={style.competentionsInfoBlock}>
                            <p>React</p>
                        </div>

                        <div className={style.dotsBlock}>

                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                        </div>

                        <div className={style.competentionsInfoBlock}>
                            <p>Redux</p>
                        </div>

                        <div className={style.dotsBlock}>

                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                        </div>

                        <div className={style.competentionsInfoBlock}>
                            <p>TypeScript</p>
                        </div>

                        <div className={style.dotsBlock}>

                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dotsWhite}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                            <span className={style.dots}></span>
                        </div>
                    </div>
                </div>

                <div className={style.CONTACTS_CONTENT}>
                    <div className={`${style.profileInfo} ${style.languages}`}>

                        <div className={style.mobileNumber}>
                            <span className={style.title}>Мобильный телефон:</span>
                            <br/>
                            <span>+375 (29) 835 61 42</span>
                        </div>

                        <div className={style.mail}>
                            <span className={style.title}>Почтовый ящик:</span>
                            <br/>
                            <span>arturexpone@yandex.ru</span>
                        </div>

                        <div className={style.adress}>
                            <span className={style.title}>Адрес:</span>
                            <br/>
                            <span>Логойский тракт, 10</span>
                            <br/>
                            <span>Минск, Беларусь</span>
                            <br/>
                            <span>220010</span>
                        </div>

                    </div>
                </div>

                <div className={style.BUTTONS}>

                    <div className={`${style.iconBtn} ${style.mail}`}>
                        <a href='mailto:arturexpone@yandex.ru' target="_blank">
                            <i className="fa fa-envelope-open-o" aria-hidden="true"></i>
                        </a>
                    </div>

                    <div className={`${style.iconBtn} ${style.in}`}>
                        <a href='https://www.linkedin.com/in/artur-matveev-23b4811a6' target="_blank">
                            <i className="fa fa-linkedin" aria-hidden="true"></i>
                        </a>
                    </div>

                    <div className={`${style.iconBtn} ${style.git}`}>
                        <a href='https://github.com/arturexpone' target="_blank">
                            <i className="fa fa-git" aria-hidden="true"></i>
                        </a>
                    </div>

                    <div className={`${style.iconBtn} ${style.tg}`}>
                        <a href='tg://resolve?domain=TrueStory1337' target="_blank">
                            <i className="fa fa-paper-plane-o" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>

            </div>
            <div className={style.DIES}>
                <div className={`${style.profileMenu} ${style.infoBlocks}`}>

                    <div className={style.nameBlock}>ПРОФИЛЬ</div>

                    <div className={style.img}>
                        <img src={avatar} className={style.img}/>
                    </div>

                </div>

                <div className={`${style.competentionsBlock} ${style.infoBlocks}`}>

                    <div className={style.nameBlock}>ТЕХНИЧЕСКИЕ НАВЫКИ</div>

                    <div className={style.img}>
                        <img src={gear} className={style.img}/>
                    </div>

                </div>

                <div className={`${style.languagesBlock} ${style.infoBlocks}`}>

                    <div className={style.nameBlock}>МОИ КОНТАКТЫ</div>

                    <div className={style.img}>
                        <img src={contact} className={style.img}/>
                    </div>

                </div>
            </div>

        </div>





    )
}